import { useParams } from 'react-router-dom';

import { AppLiveStreamsPage } from '~/components/pages/AppLiveStreamsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppLiveStreamsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppLiveStreamsPage appId={appId} />
    </DashboardTemplate>
  );
};
